import React, { useEffect, useState } from "react";
import OrderGrid from "./OrderGrid";
import {
  Button,
  FallBack,
  FlexLayout,
  Modal,
  TextStyles,
} from "@cedcommerce-integration/ounce-ui";
import { getMethod } from "../../../../../apiMethods/methods";
import { getOrderAPI } from "../../../../../APIs/PanelAPI";
import Filters from "./Filters";
import { withRouter } from "react-router-dom";
import { AlertTriangle } from "react-feather";
import { NoOrder, NoSearchOrder } from "../../../../shared/IconSvg";
import FallbackGrid from "../../../../shared/FallbackGrid";
import {
  OrderGridSkeleton,
  OrderSkeleton,
} from "../../Skeleton/OrderListingSearch";

function Failed(props) {
  let { tableColumns, fallbackStatusNoOrdersFailed } = props;

  const [orderSkeleton, setOrderSkeleton] = useState(true);
  const [gridSkeleton, setGridSkeleton] = useState(true);
  const [orderData, setOrderData] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [failedModal, setFailedModal] = useState(false);
  const [errorModalData, setErrorModalData] = useState({
    heading: "",
    message: "",
  });
  const [payloadState, setPayloadState] = useState({
    activePage: 1,
    count: 10,
  });
  const [locale, setLocale] = useState("");

  // no search order found
  const [
    fallbackStatusNoSearchOrdersFailed,
    setFallbackStatusNoSearchOrdersFailed,
  ] = useState(false);

  const getOrderDataFunc = async (payloadData) => {
    const time1 = new Date();
    let ms1 = time1.getTime();
    setFallbackStatusNoSearchOrdersFailed(false);
    setGridSkeleton(true);
    let payload = {
      "filter[object_type][1]": "source_order",
      "filter[targets.status][1]": "failed",
    };
    payload = { ...payload, ...payloadData };
    let { success, data } = await getMethod(getOrderAPI, payload);
    const time2 = new Date();
    let ms2 = time2.getTime();
    let timeOut = ms2 - ms1;
    if (success) {
      if (
        (JSON.stringify(payloadData).includes("marketplace_reference_id") ||
          JSON.stringify(payloadData).includes("created_at")) &&
        data?.["rows"].length == 0
      ) {
        setFallbackStatusNoSearchOrdersFailed(true);
      }
      if (data?.["rows"]) {
        setDataCount(data?.count);
        let tempOrderData = [];
        tempOrderData = data.rows.map((orderDataObj, index) => {
          let {
            customer,
            targets,
            marketplace_reference_id,
            items,
            created_at,
            cif_order_id,
          } = orderDataObj;
          const shoplineId = targets?.filter((target) => {
            return target?.["marketplace"] === "shopline" && target?.order_id;
          })?.[0]?.order_id;
          let tempObj = {};
          tempObj["key"] = index;
          tempObj["shoplineOrder_id"] = shoplineId ?? "";
          tempObj["order_id"] = (
            <FlexLayout direction="vertical" spacing="extraTight" wrap="noWrap">
              {marketplace_reference_id ? (
                <FlexLayout spacing="extraTight" wrap="noWrap">
                  <TextStyles fontweight="bold" type="Paragraph" paragraphTypes="MD-1.4" lineHeight="LH-2.0">eBay:</TextStyles>
                  <TextStyles textcolor="light" utility="text-ellipsis" type="Paragraph" paragraphTypes="MD-1.4" lineHeight="LH-2.0">
                    {marketplace_reference_id}
                  </TextStyles>
                </FlexLayout>
              ) : (
                <></>
              )}
              {shoplineId ? (
                <FlexLayout spacing="extraTight" wrap="noWrap">
                  <TextStyles fontweight="bold" type="Paragraph" paragraphTypes="MD-1.4" lineHeight="LH-2.0">Shopline:</TextStyles>
                  <TextStyles textcolor="light" utility="text-ellipsis" type="Paragraph" paragraphTypes="MD-1.4" lineHeight="LH-2.0">
                    {shoplineId}
                  </TextStyles>
                </FlexLayout>
              ) : (
                <></>
              )}
            </FlexLayout>
          );
          tempObj["full_name"] = <TextStyles textcolor="light" type="Paragraph" paragraphTypes="MD-1.4" lineHeight="LH-2.0">{customer?.name}</TextStyles>;
          tempObj["created_date"] = <TextStyles textcolor="light" type="Paragraph" paragraphTypes="MD-1.4" lineHeight="LH-2.0">{new Date(created_at).toISOString().split("T")[0]}</TextStyles>;
          tempObj["order_status"] = (
            <span className=" errorBtn">
              <Button
                type="DangerPlain"
                content="Failed"
                onClick={() => {
                  let tempErrorModalData = { ...errorModalData };
                  tempErrorModalData["heading"] = marketplace_reference_id;
                  tempErrorModalData["message"] = targets[0]?.errors[0];
                  setErrorModalData(tempErrorModalData);
                  setFailedModal(!failedModal);
                }}
              />
            </span>
          );
          tempObj["quantity"] = <TextStyles type="Paragraph" paragraphTypes="MD-1.4" lineHeight="LH-2.0" textcolor="light">{items.reduce((total, current) => {
            return total + Number(current.qty);
          }, 0)}</TextStyles>;
          tempObj["price"] = <TextStyles textcolor="light" type="Paragraph" paragraphTypes="MD-1.4" lineHeight="LH-2.0">{`$${items.reduce((total, current) => {
            return Number(total) + Number(current.price);
          }, 0)}`}</TextStyles>;
          tempObj["actions"] = (
            <Button
              type="TextButton"
              content="View"
              onClick={() => {
                window.scrollTo(0, 0);
                props.history.push(`/panel/order-view?id=${cif_order_id}`);
              }}
            />
          );
          return tempObj;
        });
        setOrderData(tempOrderData);
      }
    }
    if (timeOut < 500) {
      setTimeout(() => {
        setGridSkeleton(false);
        setOrderSkeleton(false);
      }, 500 - timeOut);
    } else {
      setGridSkeleton(false);
      setOrderSkeleton(false);
    }
  };

  useEffect(() => {
    getOrderDataFunc({
      ...payloadState,
      activePage: activePage,
      count: pageSize,
    });
  }, [activePage, pageSize, payloadState]);

  useEffect(() => {
    if (fallbackStatusNoOrdersFailed) {
      setLocale(
        <FallBack
          FallBackHeight="NormalPage"
          illustration={NoOrder}
          title="No Order Found!"
          subTitle="Seems like you haven't received any orders yet!"
        />
      );
    }
    if (fallbackStatusNoSearchOrdersFailed) {
      setLocale(
        <FallBack
          FallBackHeight="NormalPage"
          illustration={NoSearchOrder}
          title="No Order Found!"
          subTitle="Your request does not match the listed orders."
        />
      );
    }
  }, [fallbackStatusNoOrdersFailed, fallbackStatusNoSearchOrdersFailed]);

  return (
    <>
      {orderSkeleton ? (
        <OrderSkeleton />
      ) : (
        <>
          {fallbackStatusNoOrdersFailed ? (
            <></>
          ) : (
            <Filters
              setActivePage={setActivePage}
              payloadState={payloadState}
              setPayloadState={setPayloadState}
            />
          )}
          {gridSkeleton ? (
            <OrderGridSkeleton />
          ) : fallbackStatusNoOrdersFailed ||
            fallbackStatusNoSearchOrdersFailed ? (
            <FallbackGrid
              columns={tableColumns}
              dataSource={orderData}
              local={locale}
              rowSelection={{}}
            />
          ) : (
            <OrderGrid
              tableColumns={tableColumns}
              dataSource={orderData}
              getOrderDataFunc={getOrderDataFunc}
              count={dataCount}
              activePage={activePage}
              setActivePage={setActivePage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              payloadState={payloadState}
              setPayloadState={setPayloadState}
            />
          )}
          {/* error modal */}
          <Modal
            closeOnEscape={true}
            overlayClose={true}
            modalSize="small"
            open={failedModal}
            heading={errorModalData["heading"]}
            close={() => {
              setFailedModal(!failedModal);
            }}
          >
            <FlexLayout spacing="tight" wrap="noWrap">
              <AlertTriangle color="#C4281C" size={20} />
              <TextStyles
                type="Paragraph"
                paragraphTypes="MD-1.4"
                lineHeight="LH-2.0"
              >
                {errorModalData["message"]}
              </TextStyles>
            </FlexLayout>
          </Modal>
        </>
      )}
    </>
  );
}

export default withRouter(Failed);
